import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { InvoiceStatus } from '../invoice/invoice.model';

@Entity('InvoiceCount', { uriName: 'counts' })
export class InvoiceCount {
  @Key status!: InvoiceStatus;
  count!: number;
  totalAmount!: number;
}
